//
//
//
//
//
//
//
//

export default {
  props: {
    label: String,
    value: [String, Number, Object, Array],
    items: {
      type: Array,
      required: true
    },
    valueString: {
      type: String,
      default: null
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    labelKey: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    colSize: {
      type: Number,
      default: 4
    },
    propForm: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    internalValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.$emit('input', val);
        if (Array.isArray(val)) {
          if (val.length > 0) {
            this.$emit('update:valueString', val.join(','));
          } else {
            this.$emit('update:valueString', '');
          }
        }
      }
    }
  },
  methods: {
    handleChange: function handleChange(val) {
      this.$emit('change', val);
    }
  }
};